// extracted by mini-css-extract-plugin
export default {"modalLink":"styles_modalLink__zL0F-"};